import { useCallback, useState } from "react";
import { MailingsBulkCreationService } from "../../../services/mailingsBulkCreation";

export const useFetchRecipientsCount = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchRecipientsCount = useCallback(async (request: any, signal: AbortSignal) => {
    try {
      setIsLoading(true);
      const res = await MailingsBulkCreationService.count(request, signal);
      setIsLoading(false);
      return res;
    } catch (error: any) {
      setIsLoading(false);
      return null;
    }
  }, []);

  return { isLoading, fetchRecipientsCount };
};
